import type { Subscription } from 'src/api/endpoints/storeApi.types';

import { subscriptionHelpers } from './subscriptionHelpers';

export const subscriptionGetPaymentInterval = (
  sub?: Subscription
): 'monthly' | 'annually' | 'biennial' | undefined => {
  if (
    !subscriptionHelpers.isStripe(sub) ||
    !subscriptionHelpers.isActive(sub)
  ) {
    return undefined;
  }

  return sub.paymentInformation?.paymentInterval || undefined;
};
